/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useContext, useEffect, useRef, useState} from "react";
import parse from 'html-react-parser';
import {useDispatch} from "react-redux";
import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";
import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";
import $ from "jquery";

import ApplicationApiContext from "@Contexts/Api";

import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";
import ApplicationRouterContext from "@Contexts/Router";

import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import USER_INTERFACE from "@Services/Application/Interfaces/Users/User";
import {HTTP_ERROR_RESPONSE_INTERFACE} from "@Services/Interfaces/Http/Response/Error";
import {ERROR_SYSTEM_MESSAGE_INTERFACE} from "@Services/Application/Interfaces/_Messages/Errors";

import DEFAULT_REQUEST_HEADERS from "@Services/Interfaces/Http/Request/Headers";


import {Redirect, NavLink} from "react-router-dom";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";


import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";
import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import {Col, Row} from "react-bootstrap";
import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";
import REST_API_REQUEST from "@Services/Utilities/Requests";

import ENV from "react-dotenv";

type AboutPageProps = {};

export const SettingsAboutPageComponent: React.FC<AboutPageProps> = (): JSX.Element | null => {

    /** @const {UserInterface | null} Application Logged User (from Global Store Object) */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;

    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);

    if (!LOGGED_USER || !LOGGED_USER?.userID) return <Redirect to={ROUTER.NOT_AUTHENTICATED.LOGIN.URL}/>;


    if (!ROUTER) return <Redirect to={"/404"}/>;

    return (
        <BlockContentContainerComponent cssClasses={"settings-page-information-data-component"}>

            <BlockContentHeaderComponent headerText={"O aplikacji"} />
            
            <Col xs={12} className={"about-component"}>
                <Row className={"about-application-component"}>
                    <Col xs={12} className={"no-list-elements-message default-system-message"}>
                        <span>{ENV?.APP_TITLE}</span><br/>
                        <span>{"Wersja 0.0.1.3"}</span>
                    </Col>
                </Row>
            </Col>            

        </BlockContentContainerComponent>
    );

}


export default SettingsAboutPageComponent;
